import * as React from "react";

import { useTheme } from "../../../providers/ThemeContext";
import { useI18n } from "../../../languages/providers/I18nProvider";
import { FooterStyles } from "./FooterStyles";
import { footerKeys } from "./FooterContent";

const FooterBottomBar = () => {
  const { theme } = useTheme();
  const { t, lang } = useI18n();
  const s = FooterStyles(theme);

  const yearNumber = new Date().getFullYear();
  const year =
    lang === "ar"
      ? new Intl.NumberFormat("ar").format(yearNumber)
      : String(yearNumber);

  return (
    <div style={s.bottom}>
      <div>{t(footerKeys.copyright)}</div>
      <div style={s.bottomRight}>
        <span style={s.badge}>{t("footer:labels:madeIn")}: UAE</span>
        <span style={s.dot} />
        <span style={s.badge}>{t("footer:labels:since")} 2001</span>
      </div>
    </div>
  );
};

export default FooterBottomBar;
